<template>

 <div>
    <hr class="my-4">
    <b-row>
      <b-col class="text-center">
        <h3 class="mb-4">{{ title }}</h3>
      </b-col>
    </b-row>
    <b-row class="text-left justify-content-end m-3">
      <b-col cols="12" lg="4" md="4" sm="12" class="mb-3">
        <div class="d-flex flex-row">
          <b-col cols="5" lg="5" md="4" class="pr-3 text-center">
            <font-awesome-icon :icon="[ 'fas', 'clock' ]" size="3x" /></i></b-col>
          <b-col cols="7" lg="7" md="8" sm="8">
            <p>{{ $store.state.globalTheme.JOIN_TEXT_ONE}}</p>
          </b-col>
        </div>
      </b-col>
      <b-col cols="12" lg="4" md="4" sm="12" class="mb-3">
        <div class="d-flex flex-row">
          <b-col cols="5" lg="5" md="4" class="pr-3 text-center">
            <font-awesome-icon :icon="[ 'fas', 'chalkboard-teacher' ]" size="3x" />
          </b-col>
          <b-col cols="7" lg="7" md="8">
            <p>{{ $store.state.globalTheme.JOIN_TEXT_TWO }}</p>
          </b-col>
        </div>
      </b-col>
      <b-col cols="12" lg="4" md="4" sm="12" class="mb-3">
        <div class="d-flex flex-row">
          <b-col cols="5" lg="5" md="4" class="pr-3 text-center">
            <font-awesome-icon :icon="[ 'fas', 'certificate' ]" size="3x" />
          </b-col>
          <b-col cols="7" lg="7" md="8">
            <p>{{ $store.state.globalTheme.JOIN_TEXT_THREE }}</p>
          </b-col>
        </div>
      </b-col>
    </b-row>
    <b-container>
      <b-row>
        <b-col v-if="!$store.getters.loggedIn" class="text-center">
          <b-button :style="{backgroundColor: $store.state.globalTheme.DEFAULT_COLOR , borderColor: $store.state.globalTheme.DEFAULT_COLOR}" type="button" :to="{name:'register'}" class="btn btn-primary btn-md">Join Today</b-button>

          <b-button v-if="url" :style="{backgroundColor: $store.state.globalTheme.DEFAULT_COLOR , borderColor: $store.state.globalTheme.DEFAULT_COLOR}" type="button" :to="{name:'login',query:{redirect:url}}" class="btn btn-primary btn-md">Login</b-button>
          <b-button v-else :style="{backgroundColor: $store.state.globalTheme.DEFAULT_COLOR , borderColor: $store.state.globalTheme.DEFAULT_COLOR}" type="button" :to="{name:'login'}" class="btn btn-primary btn-md">Login</b-button>

        </b-col>
        <b-col v-if="$store.getters.loggedIn" class="text-center">
          <b-button v-if="$store.getters.loggedIn" :style="{backgroundColor: $store.state.globalTheme.DEFAULT_COLOR , borderColor: $store.state.globalTheme.DEFAULT_COLOR}" type="button" :to="{name:'gallery'}" class="btn btn-primary btn-md">Open {{ $store.state.globalTheme.GALLERY_ALIAS }}</b-button>
        </b-col>
      </b-row>
    </b-container>
    <hr class="my-4">
  </div>

</template>

<script>
    export default {
        name: "JoinToday.vue",
        props: ['title','url']
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/JoinToday.vue